import jwt_decode from "jwt-decode";

const EMAILS_SIN_COSTOS = new Set([
  "andresriera9999@gmail.com",
  "diazmariavictoria19@gmail.com",
]);

export const getUsuarioActual = () => {
  const token = localStorage.getItem("token") || "";

  if (!token) return null;

  try {
    const decoded = jwt_decode(token);

    return (
      decoded?.usuario ||
      decoded?.user ||
      decoded ||
      null
    );
  } catch (error) {
    return null;
  }
};

export const puedeVerCostosFront = () => {
  const usuario = getUsuarioActual();

  if (!usuario) return false;

  const role = String(usuario.role || "")
    .trim()
    .toUpperCase();

  // Solamente ROOT y ADMIN.
  if (!["ROOT_ROLE", "ADMIN_ROLE"].includes(role)) {
    return false;
  }

  const email = String(usuario.email || "")
    .trim()
    .toLowerCase();

  // Capa visual extra para los dos ADMIN restringidos.
  if (EMAILS_SIN_COSTOS.has(email)) {
    return false;
  }

  // Si el token nuevo ya trae el permiso desde backend,
  // también lo respetamos.
  if (usuario.puedeVerCostos === false) {
    return false;
  }

  return true;
};